import { axiosAPI, responseHandler } from 'utils';

export default {
  getList: () => responseHandler(axiosAPI.get('api/currencies')),
};
